<template>
  <span
    :class="[
      'caption',
      selected
        ? `bg-[#14e29c] border-[#14e29c] selected bg-${color} border-${color}`
        : 'border-neutral-500',
    ]"
  >
    <slot></slot>
  </span>
</template>

<script setup lang="ts">
type Props = {
  color: String;
  selected: Boolean;
};

const props = defineProps<Props>();
</script>

<style scoped>
span {
  @apply inline-block text-neutral-500 border rounded px-3 mr-2 mb-2 cursor-pointer;

  font-weight: 500;
  font-size: 12px;
  letter-spacing: 0.4px;
}

span.not-visible {
  @apply opacity-0;
}

span.selected {
  @apply text-white;
}
</style>
